<ul>
  <li *ngIf='hasElevatedPrivileges' (click)="onDismiss('add')">Add User</li>
  <li *ngIf='hasElevatedPrivileges' (click)="onDismiss('remove')">Remove User(s)</li>
  <li (click)="onDismiss('unlink')">Unlink Kiln</li>
</ul>
